import originalStatistic from '@moeinmdn/mixitweb-front-modules/src/plugin/Modules/Statistic'
import {getAxiosInstance} from '@moeinmdn/mixitweb-front-modules/src/plugin/utils/setInstance.js'

export default {
    ...originalStatistic,
    actions: {
        ...originalStatistic.actions,
        async sales({commit}, form = {}) {
            const axios = getAxiosInstance()
            return await axios.get('statistic/sales', {params: form})
        },
    },
}
